module.exports = __webpack_public_path__ + "static/media/forest-world-small.956a3137.jpg";